import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'cx_foundations-self_serve_topic_csat-click';
/**
 * Used to collect CSAT in full-page self-serve experience help-center
 */
export function trackCxFoundationsSelfServeTopicCsatClick(TopicId, CSATResult2, retailerOrBrandToken3) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { TopicId, CSATResult2, retailerOrBrandToken3 },
    });
}
